/**
 * Skimlinks server-side Link Wrapper.
 *
 * Wraps an external URL so clicks route through Skimlinks for affiliate tracking,
 * without relying on their global JS script (which used to mangle encoded URLs).
 */

const SKIMLINKS_WRAPPER_URL = 'https://go.skimresources.com';

const isAlreadyWrapped = (url: string): boolean => url.includes(SKIMLINKS_WRAPPER_URL);

export const wrapSkimlinks = (url: string, xcust?: string): string => {
  const publisherId = process.env.NEXT_PUBLIC_SKIMLINKS_PUBLISHER_ID;

  if (!publisherId || isAlreadyWrapped(url)) {
    return url;
  }

  const xcustParam = xcust ? `&xcust=${encodeURIComponent(xcust)}` : '';

  return `${SKIMLINKS_WRAPPER_URL}?id=${publisherId}&url=${encodeURIComponent(url)}${xcustParam}`;
};
